import React, { Component } from 'react';

const dadataApiKey = process.env?.DADATA_API_KEY || '318c0272e1d69ceed262f4345982fc0bce695feb';

class InputCity extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value || '',
      suggestions: [],
      showSuggestions: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { value } = this.props;
    if (value != this.state.value) {
      this.setState({
        value,
      });
    }
  }

  getInput() {
    const { 
      disabled, 
      name, 
      placeholder, 
      onBlur, 
      className, 
      error, 
      validator, 
      required 
    } = this.props;
    const { value } = this.state;

    const classes = ['inp__field'];

    if(validator && required){
      if (error && !(validator(value) && value)) classes.push('inp__field--error');
    } else if (error) classes.push('inp__field--error');

    return (
      <input
        type="text"
        disabled={disabled}
        className={className || classes.join(' ')}
        placeholder={placeholder}
        name={name}
        onFocus={() => this.setState({ showSuggestions: true })}
        onChange={e => this.onChange(e.target.value)}
        onBlur={e => this.onBlur(e)}
        value={value}
      />
    );
  }

  onBlur(e) {
    const parent = this;
    setTimeout(function() {
      parent.setState({ showSuggestions: false });
    }, 200);
    this.props.onBlur(e);
  }

	fetchSuggestions(string) {
		fetch(
			'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
			{
				method: 'POST',
				headers: {
					'content-type': 'application/json',
					accept: 'application/json',
					authorization: `Token ${dadataApiKey}`,
				},
				body: JSON.stringify({
					query: `город ${string}`,
					count: 10,
				}),
			},
		)
			.then(response => response.json())
			.then(response => {
				this.setState({ suggestions: response.suggestions });
			})
			.catch(err => {
				// console.error('Dadata request error', err);
			});
	}

  onChange(value, kladr = null) {
    const { onChange, name } = this.props;
    if (value.length > 2) {
      this.fetchSuggestions(value);
    }

    this.setState({
      value
    });

    onChange(value, {
      typeOfEntity: 'city',
      city_kladr_id: kladr,
    });
  }

  getSuggestions() {
    const { suggestions, showSuggestions } = this.state;

    if (suggestions.length && showSuggestions) {
      const cities = [];
      const suggestionsHtml = suggestions
        .filter(s => s.data.city)
        .map(s => {
          if (!cities.includes(s.data.city)) {
            cities.push(s.data.city);
            return (
              <button
                key={s.data.city}
                onClick={() => this.onChange(s.data.city, s.data.city_kladr_id)}
                className="dadata-suggestions__item"
              >
                {s.data.city}
              </button>
            );
          }
          return null;
        });
      return <div className="dadata-suggestions">{suggestionsHtml}</div>;
    }

    return null;
  }

  getIcon() {
    const {
      required,
      value,
      validator,
      error
    } = this.props;

    if(validator && required){
      if(validator(value)){
        return <div className="inp__field--success-icon" />;
      } else {
        return <div className="inp__field--error-icon" />;
      };
    } else if(error) return <div className="inp__field--error-icon" />;
  }

  render() {
    const { showSuggestions } = this.state;
    const { accent, center, error, required, value, date, label, labelClassName } = this.props;
    const classes = [labelClassName, 'inp--dadata-suggestions'];
    if (showSuggestions) classes.push('inp--dadata-suggestions-show');

    return (
      <label className={classes.join(' ')}>
        {this.getInput()}
        {this.getSuggestions()}
        <p className="inp__label">{label}</p>
        { this.getIcon() }
      </label>
    );
  }
}

export default InputCity;
